import { render } from "./ForkPreview.vue?vue&type=template&id=35fb9cc6&scoped=true"
import script from "./ForkPreview.vue?vue&type=script&lang=js"
export * from "./ForkPreview.vue?vue&type=script&lang=js"

import "./ForkPreview.vue?vue&type=style&index=0&id=35fb9cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fb9cc6"]])

export default __exports__